import React, { FunctionComponent, useEffect } from 'react';
import ChatButton from './chat-button/chat-button';
import ChatPopup from './chat-popup/chat-popup';
import ChatNotification from './chat-notifications/chat-notifications';
import { useStore } from '../../store/store-provider';
import { observer } from 'mobx-react';
import { getMixpanelService } from '../../utils/services/mixpanel-service-instance';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../constans/mixpanel-contants';
import './chat.scss';


const Chat: FunctionComponent = (): JSX.Element => {
  const { chatStore: { isVisible, toggleChatBoxVisibility, onCreateChatMessagesSubscriptions, getChatMessages }, podiumInfoStore } = useStore();
  const { getPresentationId } = podiumInfoStore;
  useEffect(() => {
    if(!getPresentationId) return;

    getChatMessages();

    const onCreateChatMessageSubscription = onCreateChatMessagesSubscriptions();

    return () => {
      onCreateChatMessageSubscription.unsubscribe();
    };
  }, []);

  const toggleChatBoxVisibilityHandler = () => {
    toggleChatBoxVisibility();
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.MESSAGES_WIDGET, MIXPANEL_EVENT_TYPES.OPENED);
  };

  return (
    <div className="chat-container">
      {!isVisible && <ChatNotification/>}
      <ChatPopup/>
      <ChatButton onClick={toggleChatBoxVisibilityHandler} isVisible={!isVisible}/>
    </div>
  );
};

export default observer(Chat);
